/* DE01OL offer-last page behaviour. Forked 2026-09-27 from dogbiotics-de01sp/src/de01sp.js (live, frozen for its
   epoch-2 read). Same gallery, buy box, cart, accordions and marquee. Changes: boots on .dbo-de01ol only, the
   in-page jumps include #offer, jump taps are tracked, the review wall has a read-more, and the fixed bars run the
   three offer-last states (Quinn 2026-09-27): JUMP above the offer (no price), HIDDEN while it is on screen,
   then DE01SP's PICK/ADD logic after it. r7 (Quinn 2026-09-29): the bars leave HIDDEN once the main Add to Cart has
   scrolled off the top (DE01SP's trigger), not the whole offer section, and Hue's add-to-cart is intercepted (below). r8: the static
   video strip's tap-to-play (the Hue widget it replaces rendered nothing; the intercept stays, defensive). */
(function () {
  // r7, Quinn R7-1 (HIGH, first deploy): Hue's add-to-cart never adds anything on this page. Restored from DE01SP commit 369bc6ff
  // (deleted there at go-live, f25e52d9): the embedded Hue player fires 'hue-add-to-cart' with Hue's configured variant (the cpdpp2
  // pool, not a de01lsp variant), and the theme layout's document listener would add it to the cart. A window capture listener runs
  // first and stops it. Then, instead of adding, she is sent to this page's own buy box (Step 1, #ds-offer) and the tap counts in the
  // jump ladder as jump_position 'hue'. Open: closing Hue's player first needs its live DOM (Quinn K-2, on www only).
  var hueJump = null;   // set by init() for the page root
  window.addEventListener('hue-add-to-cart', function (e) { e.stopImmediatePropagation(); e.stopPropagation(); if (hueJump) hueJump(); }, true);

  function init(root) {
    if (root.dataset.dsInit) return;
    root.dataset.dsInit = '1';
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    // one-of-many selection helper: marks the picked element .is-on, returns its index
    function group(sel, onPick) {
      var items = $$(sel);
      items.forEach(function (el, i) {
        el.addEventListener('click', function () {
          items.forEach(function (x) { x.classList.toggle('is-on', x === el); x.setAttribute('aria-pressed', x === el ? 'true' : 'false'); });
          if (onPick) onPick(i, el);
        });
      });
    }

    // ---- gallery: desktop thumbs ----
    // desktop galleries: wired per instance (the offer block carries a second copy, Pixel 7c)
    $$('.ds-gal-d').forEach(function (gal) {
      var main = gal.querySelector('.ds-gal-main img');
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.ds-thumb'));
      thumbs.forEach(function (el) {
        el.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.toggle('is-on', x === el); x.setAttribute('aria-pressed', x === el ? 'true' : 'false'); });
          if (main) main.src = el.querySelector('img').src;
        });
      });
    });

    // ---- gallery: mobile slider ----
    var slider = $('.ds-slider');
    var dots = $$('.ds-gal-m .ds-dot');
    if (slider) {
      var step = function () { var f = slider.firstElementChild; return f ? f.offsetWidth + 2 : slider.clientWidth; };
      var go = function (i) { var n = Math.max(0, Math.min(slider.children.length - 1, i)); slider.scrollTo({ left: n * step(), behavior: 'smooth' }); };
      var cur = function () { return Math.round(slider.scrollLeft / step()); };
      var ap = $('.ds-arrow-p'), an = $('.ds-arrow-n');
      if (ap) ap.addEventListener('click', function () { go(cur() - 1); });
      if (an) an.addEventListener('click', function () { go(cur() + 1); });
      slider.addEventListener('scroll', function () { var c = cur(); dots.forEach(function (d, i) { d.classList.toggle('is-on', i === c); }); }, { passive: true });
    }

    // ---- buy box: offer ladder mirrored from the LIVE /products/cpdpp2 (CEO 2026-09-24) ----
    // Size x pack x one-time/subscribe. Same numbers as build.py LADDER/DPJ; change both together.
    var DPJ = { tiny: 60, medium: 30, large: 20 };
    var LADDER = {
      tiny: { qty: [1, 2, 3], orig: [99, 198, 297], onetime: [49.97, 89.97, 119.97], subscribe: [44.97, 79.97, 99.97] },
      ml:   { qty: [1, 3, 5], orig: [99, 299, 499], onetime: [49.97, 99.96, 149.97], subscribe: [39.98, 79.97, 129.97] }
    };
    var plans = $$('.ds-plan'), weights = $$('.ds-weight'), modes = $$('.ds-po-head');
    // CPDPP2 purchase-option block (2026-09-26): one set of steps, moved into whichever card is open
    var offer = $('.ds-offer'), steps = $('.ds-steps');
    function placeSteps() {
      if (!offer || !steps) return;
      var st = idx(modes) === 0 ? 'onetime' : 'subscribe';
      offer.setAttribute('data-state', st);
      var body = offer.querySelector('.ds-po[data-option="' + st + '"] .ds-po-body');
      if (body && steps.parentNode !== body) body.appendChild(steps);
    }
    var wasEl = $('.ds-sticky-p span'), nowEl = $('.ds-sticky-p strong');
    var idx = function (list) { for (var i = 0; i < list.length; i++) if (list[i].classList.contains('is-on')) return i; return 0; };
    var money = function (n) { return '$' + n.toFixed(2); };
    function renderOffer() {
      var wEl = weights[idx(weights)], w = (wEl && wEl.dataset.weight) || 'medium';
      var L = LADDER[w === 'tiny' ? 'tiny' : 'ml'], dpj = DPJ[w] || 30;
      var mode = idx(modes) === 0 ? 'onetime' : 'subscribe';
      placeSteps();
      plans.forEach(function (card, i) {
        var days = L.qty[i] * dpj, price = L[mode][i], m = days / 30;
        card.querySelector('.ds-plan-name').textContent = dpj >= 30 ? m + ' ' + (m === 1 ? 'Month' : 'Months') + ' Supply' : days + ' Days Supply';
        card.querySelector('.ds-pd').textContent = '$' + (price / days).toFixed(2);
        card.querySelector('.ds-was').textContent = money(L.orig[i]);
        var sv = card.querySelector('.ds-save'); if (sv) { sv.textContent = 'Save $' + Math.round(L.orig[i] - price); sv.hidden = i === 0; }
        card.querySelector('.ds-now').textContent = money(price);
        var fs = card.querySelector('.ds-fs'); if (fs) fs.hidden = price < 60; // Free Shipping $60+
      });
      var p = idx(plans), pct = Math.round((L.onetime[p] - L.subscribe[p]) / L.onetime[p] * 100);
      $$('.ds-pct').forEach(function (el) { el.textContent = pct; });
      if (wasEl) wasEl.textContent = money(L.orig[p]);
      if (nowEl) nowEl.textContent = money(L[mode][p]);
      // desktop sticky bar (Pixel spec 3c): summary built only from labels already on the page
      var dwas = $('.ds-dsticky-was'), dnow = $('.ds-dsticky-now');
      // weight shows only in ADD mode (Zara gate: a PICK bar must not name a size while asking her to pick one)
      var dW = $('.ds-dsum-w'), dR = $('.ds-dsum-r');
      if (dW && wEl) dW.textContent = wEl.getAttribute('data-label') + ' \u00b7 ';
      if (dR) dR.textContent = [plans[p].querySelector('.ds-plan-name').textContent, modes[idx(modes)].getAttribute('data-short')].join(' \u00b7 ');
      if (dwas) dwas.textContent = money(L.orig[p]);
      if (dnow) dnow.textContent = money(L[mode][p]);
    }
    // ---- Add to cart (live 2026-09-24). Variant + Loop plan per size|pack, from offers-map.json. Loop plans are the
    // same ids cpdpp2 uses (verified per variant). Keys: data-weight | pack index (0 starter, 1 middle, 2 largest).
    // r7 (Kai 2026-09-29): variant ids are de01lsp's (product 9044097499229, create-product-de01lsp.response.json), matched
    // by SKU. Plan ids are DE01SP's; they hold only once Loop plans are attached to de01lsp. Verify per variant from /products/de01lsp.js.
    var OFFERS = {"tiny|0": [48905578152029, 7572258909], "tiny|1": [48905578250333, 7572127837], "tiny|2": [48905578283101, 7572324445], "medium|0": [48905578184797, 4181950557], "medium|1": [48905578315869, 4181983325], "medium|2": [48905578381405, 8304984157], "large|0": [48905578217565, 4182048861], "large|1": [48905578348637, 4182081629], "large|2": [48905578414173, 8305115229]};
    function selection() {
      var wEl = weights[idx(weights)], w = (wEl && wEl.dataset.weight) || 'medium';
      var o = OFFERS[w + '|' + idx(plans)];
      return o ? { id: o[0], plan: idx(modes) === 1 ? o[1] : null } : null;
    }
    $$('button.ds-atc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sel = selection(); if (!sel) return;
        var body = { id: sel.id, quantity: 1 }; if (sel.plan) body.selling_plan = sel.plan;
        var label = btn.textContent; btn.disabled = true; btn.textContent = 'Adding...';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { if (!r.ok) throw new Error('cart add ' + r.status); return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { btn.disabled = false; btn.textContent = label; alert('Could not add to cart. Please try again.'); });
      });
    });

    group('.ds-weight', renderOffer);
    group('.ds-plan', renderOffer);
    group('.ds-po-head', renderOffer);
    renderOffer();

    // ---- ship date: today + 2 days ----
    var ship = $('.ds-ship-date');
    if (ship) ship.textContent = new Date(Date.now() + 2 * 864e5).toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });

    // ---- review avatars: random order, as in the template ----
    var av = $('.ds-rev-av');
    if (av) {
      var kids = Array.prototype.slice.call(av.children);
      for (var k = kids.length - 1; k > 0; k--) { var j = Math.floor(Math.random() * (k + 1)); var t = kids[k]; kids[k] = kids[j]; kids[j] = t; }
      kids.forEach(function (c) { av.appendChild(c); });
    }

    // ---- accordions: one open at a time per group ----
    function accordion(itemSel, btnSel, chevOpen, chevShut) {
      var items = $$(itemSel);
      items.forEach(function (it) {
        var btn = it.querySelector(btnSel);
        btn.addEventListener('click', function () {
          var open = !it.classList.contains('is-open');
          items.forEach(function (x) {
            var on = x === it && open;
            x.classList.toggle('is-open', on);
            x.querySelector(btnSel).setAttribute('aria-expanded', on ? 'true' : 'false');
            x.querySelector('.ds-chev').textContent = on ? chevOpen : chevShut;
          });
        });
      });
    }
    accordion('.ds-tab', '.ds-tab-btn', '︿', '﹀');
    accordion('.ds-faq', '.ds-faq-btn', '︿', '›');
    // closing CTA: smooth scroll back to Step 1 (the href keeps it working without JS)
    // (also the guarantee band's CTA: every link to #ds-offer)
    // smooth in-page jumps: to Step 1 (#ds-offer) and to the reviews wall (#ds-reviews); the hrefs work without JS
    ['#offer', '#ds-offer', '#ds-reviews'].forEach(function (id) {
      var t = $(id);
      if (t) $$('a[href="' + id + '"]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }); });
    });
    var lastJump = null;   // read by the offer-reach event below (Quinn r1 M1)
    // jump taps: one named event per tap (Pixel 2, data-jump on every jump, Blake reads the jump-tap rate)
    $$('a[data-jump]').forEach(function (a) {
      a.addEventListener('click', function () {
        lastJump = { slot: a.getAttribute('data-jump'), t: Date.now() };
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'de01ol_jump', jump_position: a.getAttribute('data-jump') }); } catch (err) {}
      });
    });
    // r7: Hue's intercepted add-to-cart lands where the jumps land, smooth, and reports in the same event shape (slot 'hue')
    var buyBox = $('#ds-offer');
    if (buyBox) hueJump = function () {
      lastJump = { slot: 'hue', t: Date.now() };
      buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'de01ol_jump', jump_position: 'hue' }); } catch (err) {}
    };
    // r8: the static video strip in s13 (ported from /products/de-01-special-offer, dbo-product.js "Video reviews"): a tap plays the
    // clip with sound and pauses the others, a second tap pauses it. Scoped to this page's root, the source's global $$ is not used.
    var vCards = $$('.video-card');
    vCards.forEach(function (card) {
      var video = card.querySelector('video');
      if (!video) return;
      card.addEventListener('click', function () {
        if (video.paused) {
          vCards.forEach(function (c) {
            var v = c.querySelector('video');
            if (v && v !== video) { v.pause(); c.classList.remove('playing'); }
          });
          video.muted = false;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
          card.classList.add('playing');
        } else {
          video.pause();
          card.classList.remove('playing');
        }
      });
      // r8 Zara gate item 3 (Kai): a tap plays the clip ONCE (no loop with sound), and it pauses when its card leaves the screen.
      // The markup keeps the source's `loop` attribute verbatim; the property is switched off here instead.
      video.loop = false;
      video.addEventListener('ended', function () { card.classList.remove('playing'); try { video.currentTime = 0.5; } catch (err) {} });
      video.addEventListener('pause', function () { card.classList.remove('playing'); });
    });
    if ('IntersectionObserver' in window && vCards.length) {
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { var v = e.target.querySelector('video'); if (v && !e.isIntersecting && !v.paused) v.pause(); });
      }, { threshold: 0 });
      vCards.forEach(function (c) { vio.observe(c); });
    }
    // recipe card, mobile: supporting cast, carrier, method and serving size behind one toggle (Quinn r1 M2)
    var rcBtn = $('.ds-rc-more'), rcSec = $('.ds-rc-fold');
    if (rcBtn && rcSec) rcBtn.addEventListener('click', function () {
      var open = !rcSec.classList.contains('is-open');
      rcSec.classList.toggle('is-open', open);
      rcBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      rcBtn.querySelector('span').textContent = rcBtn.getAttribute(open ? 'data-open' : 'data-shut');
      rcBtn.querySelector('.ds-chev').textContent = open ? '\ufe3f' : '\ufe40';
    });
    // section 9, mobile: cards 4 to 6 wait behind "Show 3 more reviews" (Pixel 5)
    var ownMore = $('.ds-own-more'), ownGrid = $('.ds-own-grid');
    if (ownMore && ownGrid) ownMore.addEventListener('click', function () { ownGrid.classList.add('is-open'); ownMore.hidden = true; });
    // section 14: the capped Loox wall opens on "Read all reviews" (Pixel 9)
    var wall = $('.ds-wall'), wallMore = $('.ds-wall-more');
    if (wall && wallMore) wallMore.addEventListener('click', function () { wall.classList.add('is-open'); });

    // ---- ingredient carousel ----
    var track = $('.ds-ing-track');
    var idots = $$('.ds-ing-dot');
    if (track) {
      var istep = function () { var f = track.firstElementChild; if (!f) return 1; return f.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0); };
      var icur = function () { return Math.round(track.scrollLeft / istep()); };
      var igo = function (i) { var n = Math.max(0, Math.min(track.children.length - 1, i)); track.scrollTo({ left: n * istep(), behavior: 'smooth' }); };
      $('.ds-ing-prev').addEventListener('click', function () { igo(icur() - 1); });
      $('.ds-ing-next').addEventListener('click', function () { igo(icur() + 1); });
      idots.forEach(function (d, i) { d.addEventListener('click', function () { igo(i); }); });
      track.addEventListener('scroll', function () { var c = icur(); idots.forEach(function (d, i) { d.classList.toggle('is-on', i === c); }); }, { passive: true });
    }

    // ---- customer photos: evergreen marquee (CEO 2026-09-24) ----
    // Moves the track left forever. The photo set is in the DOM twice, so when the offset passes one
    // set's width it wraps by exactly that width and the jump is invisible. Pauses on hover/touch,
    // stops while off screen, and stays still for prefers-reduced-motion.
    var mq = $('.ds-marquee'), mtrack = $('.ds-marquee-track');
    if (mq && mtrack) {
      var SPEED = 40; // px per second
      var half = mtrack.children.length / 2;
      var setW = 0, off = 0, last = 0, paused = false, onScreen = true, raf = 0;
      var measure = function () { var a = mtrack.children[0], b = mtrack.children[half]; setW = a && b ? b.offsetLeft - a.offsetLeft : 0; };
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      var frame = function (t) {
        raf = 0;
        if (last) {
          var dt = Math.min(t - last, 100) / 1000; // clamp so a background tab does not lurch on return
          if (!paused && setW) { off -= SPEED * dt; if (off <= -setW) off += setW; mtrack.style.transform = 'translate3d(' + off + 'px,0,0)'; }
        }
        last = t;
        run();
      };
      var run = function () { if (!raf && onScreen && !(reduce && reduce.matches)) raf = requestAnimationFrame(frame); };
      var stop = function () { if (raf) cancelAnimationFrame(raf); raf = 0; last = 0; };
      mq.addEventListener('mouseenter', function () { paused = true; });
      mq.addEventListener('mouseleave', function () { paused = false; });
      mq.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      mq.addEventListener('touchend', function () { paused = false; }, { passive: true });
      window.addEventListener('resize', function () { measure(); if (setW) off = off % setW; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; if (onScreen) run(); else stop(); }).observe(mq);
      }
      if (reduce && reduce.addEventListener) reduce.addEventListener('change', function () { if (reduce.matches) stop(); else run(); });
      measure();
      run();
    }

    // ---- fixed bars, four states (Pixel 8, Quinn 2026-09-27) ----
    // none:   the hero jump is on screen (includes page load)
    // jump:   the hero jump has left the top AND the offer section has not reached the screen. No price in the bar.
    // hidden: the offer section has reached the screen and the main Add to Cart has not yet left its top (one add button per screen)
    // after:  the main Add to Cart is fully above the screen (r7, Quinn R7-4: DE01SP's trigger; before r7 it waited for the whole
    //         offer section, which left about 590px at 390 with no add button and no bar, more than a screen with Hue under the
    //         review). DE01SP's PICK (to Step 1) until a pick is made, then ADD.
    // HIDDEN always sits between JUMP and AFTER, so the bar never swaps content while it is on screen.
    var mbar = $('.ds-sticky'), dbar = $('.ds-dsticky'), offerSec = $('.ds-offer-sec'), heroJump = $('[data-jump="hero"]'), atcMain = $('.ds-atc-main');
    if (offerSec && atcMain && (mbar || dbar)) {
      var chosen = false, ticking = false, offerSeen = false, closeSeen = false, closeTimer = null, closeSec = $('.ds-close'), loadedOnOffer = location.hash === '#offer';
      var s5Sec = $('.ds-results'), s5Seen = false;   // r9 (Quinn r9 placement ruling section 7): the s5 section_view diagnostic
      var check = function () {
        ticking = false;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var r = offerSec.getBoundingClientRect();
        var h = heroJump ? heroJump.getBoundingClientRect() : { bottom: -1 };
        var state = atcMain.getBoundingClientRect().bottom < 0 ? 'after' : (r.top < vh ? 'hidden' : (h.bottom < 0 ? 'jump' : 'none'));
        // Quinn r1 M1: one de01ol_offer_view per pageview, the first time any part of the offer is on screen or passed.
        // via = the jump slot tapped in the last 5s, 'deeplink' if the page loaded on #offer, else 'scroll'.
        if (!offerSeen && state !== 'jump' && state !== 'none') {
          offerSeen = true;
          var via = (lastJump && Date.now() - lastJump.t < 5000) ? lastJump.slot : (loadedOnOffer ? 'deeplink' : 'scroll');
          try { (window.dataLayer = window.dataLayer || []).push({ event: 'de01ol_offer_view', via: via }); } catch (err) {}
        }
        // r9 (Quinn section 7, diagnostics only, OL-only): one de01ol_section_view {section:'s5'} per pageview, when s5's top crosses 50%
        // of the viewport (continuation from the s4 mechanism chain into the receipts). via mirrors offer_view.
        if (!s5Seen && s5Sec && s5Sec.getBoundingClientRect().top < vh * 0.5) {
          s5Seen = true;
          var svia = (lastJump && Date.now() - lastJump.t < 5000) ? lastJump.slot : (loadedOnOffer ? 'deeplink' : 'scroll');
          try { (window.dataLayer = window.dataLayer || []).push({ event: 'de01ol_section_view', section: 's5', via: svia }); } catch (err) {}
        }
        // Quinn r4 (gate M2): one de01ol_close_view per pageview, fired only after section 12 has been ON screen for 1s,
        // so boot deep links and jump taps that scroll past it do not count. via mirrors offer_view.
        if (!closeSeen && closeSec && !closeTimer) {
          var cr = closeSec.getBoundingClientRect();
          if (cr.top < vh && cr.bottom > 0) {
            closeTimer = setTimeout(function () {
              closeTimer = null;
              var r2 = closeSec.getBoundingClientRect(), vh2 = window.innerHeight || document.documentElement.clientHeight;
              if (closeSeen || !(r2.top < vh2 && r2.bottom > 0)) return;
              closeSeen = true;
              var cvia = (lastJump && Date.now() - lastJump.t < 5000) ? lastJump.slot : (loadedOnOffer ? 'deeplink' : 'scroll');
              try { (window.dataLayer = window.dataLayer || []).push({ event: 'de01ol_close_view', via: cvia }); } catch (err) {}
            }, 1000);
          }
        }
        [mbar, dbar].forEach(function (bar) {
          if (!bar) return;
          bar.setAttribute('data-state', state);
          bar.classList.toggle('is-add', state === 'after' && chosen);
          bar.classList.toggle('is-visible', state === 'jump' || state === 'after');
        });
      };
      var queue = function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
      $$('.ds-weight, .ds-plan, .ds-po-head').forEach(function (el) { el.addEventListener('click', function () { chosen = true; queue(); }); });
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      check();
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.dbo-de01ol'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', boot);
})();
